import React, {Component} from 'react'
import $ from 'jquery'
import '../common/highlight-within-textarea/jquery.highlight-within-textarea.js'
import 'highlight-within-textarea/jquery.highlight-within-textarea.css'

class FormulaInput extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            name: this.props.name || '',
            value: this.props.value || '',
            id: this.props.id || '',
            rows: this.props.rows || 2,
            className: this.props.className || '',
            onChange: this.props.onChange || function () {},
        }

    }

    componentDidMount() {


        $('#' + this.state.id).highlightWithinTextarea({
            highlight: [
                {
                    highlight: 'unit_price',
                    className: 'hwt-variable'
                },
                {
                    highlight: 'unit_cost',
                    className: 'hwt-variable'
                },
                {
                    highlight: 'quantity',
                    className: 'hwt-variable'
                },
                {
                    highlight: 'combined_quantity',
                    className: 'hwt-variable'
                },
                {
                    highlight: '?',
                    className: 'hwt-condition'
                },
                {
                    highlight: ':',
                    className: 'hwt-condition'
                },
                {
                    highlight: '>',
                    className: 'hwt-operator'
                },
                {
                    highlight: '>=',
                    className: 'hwt-operator'
                },
                {
                    highlight: '<=',
                    className: 'hwt-operator'
                },
                {
                    highlight: '<',
                    className: 'hwt-operator'
                },
                {
                    highlight: ')',
                    className: 'hwt-operator'
                },
                {
                    highlight: '(',
                    className: 'hwt-operator'
                },
                {
                    highlight: '+',
                    className: 'hwt-operator'
                },
                {
                    highlight: '-',
                    className: 'hwt-operator'
                },
                {
                    highlight: '*',
                    className: 'hwt-operator'
                },
                {
                    highlight: '/',
                    className: 'hwt-operator'
                },
            ] // string, regexp, array, function, or custom object
        });
    }
    componentWillReceiveProps(nextProps) {
        this.setState({
            name: nextProps.name || '',
            value: nextProps.value || '',
            id: nextProps.id || '',
            rows: nextProps.rows || 2,
            className: nextProps.className || '',
            onChange: nextProps.onChange || function () {},
        }, () => {

        })

    }

    render() {
        return (
            <textarea
                name={this.state.name}
                value={this.state.value}
                onChange={this.state.onChange}
                id={this.state.id}
                rows={this.state.rows}
                className={this.state.className}
                style={{
                    padding: "0.375rem 0.75rem"
                }}
            />
        )
    }
}

export default FormulaInput





// WEBPACK FOOTER //
// ./src/product/formulainput.component.jsx